import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';

import { MODULE_ROUTES } from '@common/constants/module-routes.const';

import { AppLoaderMfeConfigService } from '../services/app-loader-mfe-config.service';

export const appLoaderGuard: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
  const appLoaderMfeConfigService = inject(AppLoaderMfeConfigService);
  const router = inject(Router);
  const code = route.paramMap.get('code');

  return appLoaderMfeConfigService.resolveMfeConfig(code).pipe(
    map(mfeConfig => {
      if (mfeConfig !== null) {
        return true;
      }
      return router.createUrlTree([`/${MODULE_ROUTES.MAIN}`, MODULE_ROUTES.NO_ACCESS]);
    })
  );
};
